import createVueComponent from '../createVueComponent';

const BookmarkMinus = createVueComponent('BookmarkMinusIcon', [
  ['path', { d: 'M19 21l-7-4-7 4V5a2 2 0 012-2h10a2 2 0 012 2v16z' }],
  ['line', { x1: '15', x2: '9', y1: '10', y2: '10' }],
]);

export default BookmarkMinus;
